import BackgroundPoderJudicial from "assets/images/tribunal-background.jpg";
import Logo from "assets/images/logoEncabezado.png";
import { Box, Typography } from "@mui/material";

export const SiteUnderMaintenanceScreen = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        backgroundImage: `url(${BackgroundPoderJudicial})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "&::before": {
          content: '""',
          display: "block",
          position: "absolute",
          backgroundColor: "#000",
          opacity: 0.5,
          width: "100vw",
          height: "100vh",
          top: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "white",
          height: "80%",
          width: "60%",
          zIndex: 1000,
          textAlign: "center",
          opacity: 0.9,
          padding: "1em",
        }}
      >
        <img src={Logo} alt="logo-poder-judicial" />
        <Typography variant="h3">Sitio en Mantenimiento</Typography>
        <Typography variant="h5" className="py-2">
          Disculpa las molestias , estamos preparando algo increible y
          emocionante para ti.
        </Typography>
        <Typography variant="h6" className="py-2">
          Si necesitas comunicarte con nostros de manera urgente puedes marcar a
          los siguientes números:
        </Typography>
        <Typography variant="h6" className="py-2">
          Tel. (722) 167-92-00 Mesa de ayuda extensión 15401
        </Typography>
      </Box>
    </Box>
  );
};
